<header class="header fixed w-100 top-0 left-0 flex flex-center z-50 border-box p-12" [class.not-fixed]="isNotFixedHeader()">
  <div class="flex justify-between items-center gap-8 w-100 sm:px-4">
    <div class="left flex items-center justify-start">
      <img src="/assets/img/logos/logo-sm.svg" alt="winthrone" width="118" height="40">
    </div>

    @if(title()) {
      <div class="text-color-1 flex flex-1 flex-center text-font-1 text-20 font-weight-700">{{ title() }}</div>
    }

    @if (!hideCloseIcon()) {
      <div class="right flex items-center justify-end">
        <app-svg-icon class="cursor-pointer" name="close-20px" [cssColor]="true" [width]="26" [height]="26" [routerLink]="['/' + lang.currentRouteLanguage]"></app-svg-icon>
      </div>
    }
  </div>
</header>
